/**
* @author 阿佑[ayooooo@petalmail.com]
* @date 2022/4/13 15:48
* @description
*   FileInput.vue of WeTrade
*/
<template>
<span @click="select">
  <slot />
  <input
    v-show="false" ref="file" :accept="accept" :multiple="multiple" type="file"
    @change="$emit('change', $event)"
  />
</span>

</template>

<script lang="ts">
import { defineComponent, shallowRef } from 'vue'

export default defineComponent({
  name: 'FileInput',
  props: {
    accept: {
      type: String,
      default: '*/*',
    },
    multiple: Boolean,
  },
  emits: ['input', 'change'],
  setup (props, ctx) {
    const file = shallowRef()

    const select = () => {
      if (file.value) {
        const input = file.value as HTMLInputElement
        input.value = ''
        input.click()
        ctx.emit('input')
      }
    }

    return {
      file,
      select,
    }
  },
})
</script>
